"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyProduct = void 0;

var _createProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty");

var _products = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/products");

var PROPERTY_KEY = 'product';
/**
 * @param {Object} upgradeData
 * @param {String} upgradeSource
 * @return {Object}
 */

var getPropertyProduct = function getPropertyProduct(_ref) {
  var upgradeProduct = _ref.upgradeProduct;
  var propertyValue = _products.products[upgradeProduct];
  return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
};

exports.getPropertyProduct = getPropertyProduct;